// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"te_a bic_rc bic_qx bic_xr","ForumPosts__contest":"te_b bic_hq","ForumPosts__counselling":"te_c"};